/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ManualPro = {
    properties: {
        expirationDate: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        user: {
            type: 'UserMini',
            isRequired: true,
        },
        createdBy: {
            type: 'UserMini',
            isRequired: true,
        },
        createDate: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
    },
} as const;
